import React, { useMemo, useEffect, useRef, useState } from 'react';
import { Box, Spinner, Center } from '@chakra-ui/react';
import { usePayments } from './../hooks/usePayments';
import UserCreateSuccessModal from './UserCreateSuccessModal';
import { patientStore } from '../store/PatientStore';
import { clinicStore } from '../store/ClinicStore';

const PaymentStep = ({
    clinic,
    patient,
    patientId,
    doctor,
    locationId,
    pmethod,
    aptypeid,
    bid,
    fees,
    isSuccessModalOpen,
    onSuccessModalClose,
    handleSuccess,
    handleError,
    handlePrevious,
}) => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const [isIframeLoading, setIsIframeLoading] = useState(true);
    const currentPatient = patientStore.currentPatient;
    console.log("Current Patient: ", currentPatient);
    const currentClinic = clinicStore.currentClinic;

    console.log("Clinic: ", clinicStore.currentClinic);

    const params = useMemo(() => ({
        req: 'cors_api',
        kiosk: currentClinic?.kiosk_serial_no,
        pname: `${patient?.first_name} ${patient?.last_name}`,
        pid: currentPatient?.id,
        pmethod,
        lid: `${doctor?.location_id}`,
        did: doctor?.doctor_id,
        aptypeid,
        bid,
        mac: '',
        room_name: '',
        fees: fees,
        // eslint-disable-next-line
    }), [currentClinic?.kiosk_serial_no, patient?.first_name, patient?.last_name, patientId, pmethod, locationId, doctor?.doctor_id, aptypeid, bid, fees]);

    console.log(params);
    const { generatePaymentUrl } = usePayments({ params });
    console.log(generatePaymentUrl);

    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = true;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        const handleMessage = (event) => {

            const iframe = document.querySelector('iframe#FamilyDoctorPaymentFrame') as HTMLIFrameElement;
            const childWindow = iframe?.contentWindow;
            if (event.source === childWindow) {
                console.log("Event Data: ", event.data);
                if (event.data.status === 1) {
                    handleSuccess(event.data.payment_id);
                } else {
                    console.log("Waiting for payment to complete...");
                    //handleError();
                }
            }
        };
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [handleError, handleSuccess]);

    return (
        <Box position="relative">
            {isIframeLoading && (
                <Center position="absolute" top={0} left={0} right={0} bottom={0} bg="white" zIndex={1}>
                    <Spinner size="xl" color="blue.500" />
                </Center>
            )}
            <iframe
                id='FamilyDoctorPaymentFrame'
                ref={iframeRef}
                title="Payment Frame"
                src={generatePaymentUrl()}
                onLoad={() => setIsIframeLoading(false)}
                style={{ width: '400px', height: '420px', border: 'none' }}
            />
            <UserCreateSuccessModal isOpen={isSuccessModalOpen} onClose={onSuccessModalClose} />
        </Box>
    );
};

export default PaymentStep;
